import React, { useState, useEffect } from 'react';
import { Grid, Typography, MenuItem, Box, CircularProgress, FormControl, InputLabel } from '@mui/material';
import Field from '../../../../components/field';

const UnitSelector = ({ selectedBuilding, selectedUnit, setSelectedUnit, buildingData }) => {
  const [units, setUnits] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Extract units from building data
  useEffect(() => {
    setIsLoading(true);
    
    if (buildingData && buildingData.units && buildingData.units.length > 0) {
      const unitOptions = buildingData.units.map(unit => ({
        value: unit.unit_id,
        label: unit.unit_number || unit.name || `Unit ${unit.floor || ''}`
      }));
      setUnits(unitOptions);
    } else {
      setUnits([]);
      setSelectedUnit('');
    }
    
    setIsLoading(false);
  }, [buildingData, setSelectedUnit]);

  return (
    <Grid item xs={12}>
      <FormControl fullWidth variant="outlined">
        <InputLabel shrink htmlFor="unit-select">
          Unit
        </InputLabel>
        <Field
          select
          id="unit-select"
          value={selectedUnit}
          onChange={(e) => setSelectedUnit(e.target.value)}
          disabled={!selectedBuilding || isLoading || !buildingData}
          defaultValue=""
          placeholder="Select unit"
        >
        <MenuItem value="" disabled>
          <em>{isLoading ? "Loading units..." : "Select unit"}</em>
        </MenuItem>
        {isLoading ? (
          <MenuItem disabled>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <CircularProgress size={20} sx={{ mr: 1 }} /> Loading...
            </Box>
          </MenuItem>
        ) : units.length > 0 ? (
          units.map((unit) => (
            <MenuItem key={unit.value} value={unit.value}>
              {unit.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No units found</MenuItem>
        )}
      </Field>
      </FormControl>
    </Grid>
  );
};

export default UnitSelector;